export const APP_REGISTRATION = "app/RegistrationPage/APP_REGISTRATION";
export const APP_REGISTRATION_SUCCESS = "app/RegistrationPage/APP_REGISTRATION_SUCCESS";
export const APP_REGISTRATION_FAILURE = "app/RegistrationPage/APP_REGISTRATION_FAILURE";

export const RESET_TO_INITIAL_STATE = "app/RegistrationPage/RESET_TO_INITIAL_STATE"